// import { useState } from "react";
// import { useTranslation } from "react-i18next";
// import SectorSupportModal from "@/pages/home/components/SectorSupportModal";
// import HealthServicesModal from "@/pages/home/components/HealthServicesModal";


// interface Sector {
//   icon: string;
//   name: string;
//   desc: string;
//   detailKey?: string;
// }

// const getSectors = (t: (key: string) => string): Sector[] => [
//   {
//     icon: "ri-heart-pulse-line",
//     name: t("sectorHealth"),
//     desc: t("sectorHealthDesc"),
//     detailKey: "sectorHealthDetail",
//   },
//   {
//     icon: "ri-building-line",
//     name: t("sectorInfrastructure"),
//     desc: t("sectorInfrastructureDesc"),
//   },
//   {
//     icon: "ri-settings-3-line",
//     name: t("sectorManufacturing"),
//     desc: t("sectorManufacturingDesc"),
//   },
//   {
//     icon: "ri-home-3-line",
//     name: t("sectorRealEstate"),
//     desc: t("sectorRealEstateDesc"),
//   },
//   {
//     icon: "ri-hammer-line",
//     name: t("sectorMining"),
//     desc: t("sectorMiningDesc"),
//   },
//   {
//     icon: "ri-earth-line",
//     name: t("sectorTourism"),
//     desc: t("sectorTourismDesc"),
//   },
//   {
//     icon: "ri-seedling-line",
//     name: t("sectorAgribusiness"),
//     desc: t("sectorAgribusinessDesc"),
//   },
//   {
//     icon: "ri-graduation-cap-line",
//     name: t("sectorEducation"),
//     desc: t("sectorEducationDesc"),
//   },
//   {
//     icon: "ri-bank-line",
//     name: t("sectorFinance"),
//     desc: t("sectorFinanceDesc"),
//   },
//   {
//     icon: "ri-restaurant-2-line",
//     name: t("sectorFood"),
//     desc: t("sectorFoodDesc"),
//   },
// ];

// function SectorCard({
//   sector,
//   onClick,
// }: {
//   sector: Sector;
//   onClick: () => void;
// }) {
//   return (
//     <div
//       onClick={onClick}
//       role="button"
//       tabIndex={0}
//       onKeyDown={(e) => {
//         if (e.key === "Enter" || e.key === " ") onClick();
//       }}
//       className="bg-white rounded-2xl p-6 border border-gray-100 hover:-translate-y-1 transition-all duration-300 group cursor-pointer hover:border-[#00C2C2]/40 hover:shadow-md"
//     >
//       <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-[#E6FAFA] mb-4">
//         <i className={`${sector.icon} text-xl text-[#00C2C2]`} />
//       </div>
//       <div className="flex items-start justify-between gap-2">
//         <h3 className="text-[#0A1628] font-bold text-sm mb-1.5 leading-snug">
//           {sector.name}
//         </h3>
//         <i className="ri-arrow-right-line text-sm text-gray-300 group-hover:text-[#00C2C2] transition-colors flex-shrink-0 mt-0.5" />
//       </div>
//       <p className="text-gray-500 text-xs leading-relaxed">{sector.desc}</p>
//     </div>
//   );
// }

// export default function RegulatedSectors() {
//   const { t } = useTranslation();
//   const sectors = getSectors(t);
//   const [activeSector, setActiveSector] = useState<Sector | null>(null);
//   const [showHealthDetail, setShowHealthDetail] = useState(false);

//   return (
//     <section className="py-28 bg-[#F5FAFA]">
//       <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-16">
//         <div className="max-w-3xl mb-16">
//           <span className="inline-block text-xs font-bold tracking-[0.2em] text-[#00C2C2] uppercase mb-3">
//             {t("sectorsTag")}
//           </span>
//           <h2 className="text-4xl lg:text-5xl font-extrabold text-[#0A1628] leading-tight mb-6">
//             {t("sectorsTitle1")}{" "}
//             <span className="text-[#00C2C2]">{t("sectorsTitle2")}</span>
//           </h2>
//           <p className="text-lg text-gray-600 leading-relaxed">
//             {t("sectorsDesc")}
//           </p>
//         </div>

//         <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-5 gap-4 mb-16 items-start">
//           {sectors.map((s) => (
//             <SectorCard
//               key={s.name}
//               sector={s}
//               onClick={() => {
//                 if (s.icon === "ri-heart-pulse-line") {
//                   setShowHealthDetail(true);
//                 } else {
//                   setActiveSector(s);
//                 }
//               }}
//             />
//           ))}
//         </div>

//         <div className="bg-[#0A1628] rounded-2xl p-10 lg:p-14 flex flex-col lg:flex-row items-center gap-10">
//           <div className="flex-1">
//             <p className="text-xl lg:text-2xl font-semibold text-white leading-relaxed">
//               &ldquo;{t("sectorsQuote")}&rdquo;
//             </p>
//             <p className="text-white/50 text-sm mt-4">{t("whyChooseTag")}</p>
//           </div>
//           <div className="flex-shrink-0 flex flex-wrap gap-2">
//             {[t("badgeLicensed"), t("badgeCompliant"), t("badgeTrusted")].map(
//               (tag) => (
//                 <span
//                   key={tag}
//                   className="px-3 py-1 rounded-full text-xs bg-white/10 text-white/70 font-medium border border-white/20"
//                 >
//                   {tag}
//                 </span>
//               )
//             )}
//           </div>
//         </div>
//       </div>

//       {showHealthDetail && (
//         <HealthServicesModal
//           onClose={() => setShowHealthDetail(false)}
//           onRequestSupport={() => {
//             setShowHealthDetail(false);
//             const healthSector = sectors.find((s) => s.icon === "ri-heart-pulse-line");
//             if (healthSector) setActiveSector(healthSector);
//           }}
//         />
//       )}

//       {activeSector && (
//         <SectorSupportModal
//           sectorName={activeSector.name}
//           sectorIcon={activeSector.icon}
//           onClose={() => setActiveSector(null)}
//         />
//       )}
//     </section>
//   );
// }



import { useState } from "react";
import { useTranslation } from "react-i18next";
import SectorSupportModal from "@/pages/home/components/SectorSupportModal";
import HealthServicesModal from "@/pages/home/components/HealthServicesModal";

// Import images from assets
import healthImg from "@/assets/images/health_1.png";
import infrastructureImg from "@/assets/images/infrastructure.jpg";
import manufacturingImg from "@/assets/images/manufacturing.jpg";
import realEstateImg from "@/assets/images/real-estate.jpg";
import miningImg from "@/assets/images/mining.jpg";
import tourismImg from "@/assets/images/tourism.jpg";
import agribusinessImg from "@/assets/images/agri.jpg";
import educationImg from "@/assets/images/education.jpg";
import financeImg from "@/assets/images/finance.jpg";
import foodImg from "@/assets/images/food.jpg";

interface Sector {
  icon: string;
  name: string;
  desc: string;
  detailKey?: string;
  image: string;
}

const getSectors = (t: (key: string) => string): Sector[] => [
  {
    icon: "ri-heart-pulse-line",
    name: t("sectorHealth"),
    desc: t("sectorHealthDesc"),
    detailKey: "sectorHealthDetail",
    image: healthImg,
  },
  {
    icon: "ri-building-line",
    name: t("sectorInfrastructure"),
    desc: t("sectorInfrastructureDesc"),
    image: infrastructureImg,
  },
  {
    icon: "ri-settings-3-line",
    name: t("sectorManufacturing"),
    desc: t("sectorManufacturingDesc"),
    image: manufacturingImg,
  },
  {
    icon: "ri-home-3-line",
    name: t("sectorRealEstate"),
    desc: t("sectorRealEstateDesc"),
    image: realEstateImg,
  },
  {
    icon: "ri-hammer-line",
    name: t("sectorMining"),
    desc: t("sectorMiningDesc"),
    image: miningImg,
  },
  {
    icon: "ri-earth-line",
    name: t("sectorTourism"),
    desc: t("sectorTourismDesc"),
    image: tourismImg,
  },
  {
    icon: "ri-seedling-line",
    name: t("sectorAgribusiness"),
    desc: t("sectorAgribusinessDesc"),
    image: agribusinessImg,
  },
  {
    icon: "ri-graduation-cap-line",
    name: t("sectorEducation"),
    desc: t("sectorEducationDesc"),
    image: educationImg,
  },
  {
    icon: "ri-bank-line",
    name: t("sectorFinance"),
    desc: t("sectorFinanceDesc"),
    image: financeImg,
  },
  {
    icon: "ri-restaurant-2-line",
    name: t("sectorFood"),
    desc: t("sectorFoodDesc"),
    image: foodImg,
  },
];

function SectorCard({
  sector,
  onClick,
}: {
  sector: Sector;
  onClick: () => void;
}) {
  return (
    <div
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") onClick();
      }}
      style={{ backgroundImage: `url(${sector.image})` }}
      className="relative bg-cover bg-center rounded-2xl p-6 border border-gray-100 hover:-translate-y-1 transition-all duration-300 group cursor-pointer hover:border-[#00C2C2]/40 hover:shadow-md overflow-hidden"
    >
      {/* Dark overlay so text stays readable over the photo */}
      <div className="absolute inset-0 bg-[#0A1628]/70 group-hover:bg-[#0A1628]/60 transition-colors" />

      <div className="relative z-10">
        <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-white/10 backdrop-blur-sm mb-4">
          <i className={`${sector.icon} text-xl text-[#00C2C2]`} />
        </div>
        <div className="flex items-start justify-between gap-2">
          <h3 className="text-white font-bold text-sm mb-1.5 leading-snug">
            {sector.name}
          </h3>
          <i className="ri-arrow-right-line text-sm text-white/40 group-hover:text-[#00C2C2] transition-colors flex-shrink-0 mt-0.5" />
        </div>
        <p className="text-white/70 text-xs leading-relaxed">{sector.desc}</p>
      </div>
    </div>
  );
}

export default function RegulatedSectors() {
  const { t } = useTranslation();
  const sectors = getSectors(t);
  const [activeSector, setActiveSector] = useState<Sector | null>(null);
  const [showHealthDetail, setShowHealthDetail] = useState(false);

  return (
    <section className="py-28 bg-[#F5FAFA]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-16">
        <div className="max-w-3xl mb-16">
          <span className="inline-block text-xs font-bold tracking-[0.2em] text-[#00C2C2] uppercase mb-3">
            {t("sectorsTag")}
          </span>
          <h2 className="text-4xl lg:text-5xl font-extrabold text-[#0A1628] leading-tight mb-6">
            {t("sectorsTitle1")}{" "}
            <span className="text-[#00C2C2]">{t("sectorsTitle2")}</span>
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed">
            {t("sectorsDesc")}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-5 gap-4 mb-16 items-start">
          {sectors.map((s) => (
            <SectorCard
              key={s.name}
              sector={s}
              onClick={() => {
                if (s.icon === "ri-heart-pulse-line") {
                  setShowHealthDetail(true);
                } else {
                  setActiveSector(s);
                }
              }}
            />
          ))}
        </div>

        <div className="bg-[#0A1628] rounded-2xl p-10 lg:p-14 flex flex-col lg:flex-row items-center gap-10">
          <div className="flex-1">
            <p className="text-xl lg:text-2xl font-semibold text-white leading-relaxed">
              &ldquo;{t("sectorsQuote")}&rdquo;
            </p>
            <p className="text-white/50 text-sm mt-4">{t("whyChooseTag")}</p>
          </div>
          <div className="flex-shrink-0 flex flex-wrap gap-2">
            {[t("badgeLicensed"), t("badgeCompliant"), t("badgeTrusted")].map(
              (tag) => (
                <span
                  key={tag}
                  className="px-3 py-1 rounded-full text-xs bg-white/10 text-white/70 font-medium border border-white/20"
                >
                  {tag}
                </span>
              )
            )}
          </div>
        </div>
      </div>

      {showHealthDetail && (
        <HealthServicesModal
          onClose={() => setShowHealthDetail(false)}
          onRequestSupport={() => {
            setShowHealthDetail(false);
            const healthSector = sectors.find((s) => s.icon === "ri-heart-pulse-line");
            if (healthSector) setActiveSector(healthSector);
          }}
        />
      )}

      {activeSector && (
        <SectorSupportModal
          sectorName={activeSector.name}
          sectorIcon={activeSector.icon}
          onClose={() => setActiveSector(null)}
        />
      )}
    </section>
  );
}